var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column ga-5 w-100" },
    [
      _vm.siteUrl && _setup.externalPagePath
        ? _c(
            "form",
            {
              staticClass: "w-100",
              attrs: {
                method: "post",
                target: "_blank",
                action: _setup.externalPagePath,
              },
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
                domProps: { value: _setup.context.csrf_token },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "domain" },
                domProps: { value: _vm.siteUrl },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "url" },
                domProps: { value: _vm.siteUrl },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "information-actions__button d-flex align-center justify-center ga-2 bg-gray-40 rounded-10 px-2 py-4 w-100 text-subtitle-1 text--text",
                  attrs: { type: "submit", "data-qa": "lpu_information_site" },
                },
                [
                  _c("span", {
                    staticClass: "ui-icon-site ui-icon-fz-big flex-shrink-0",
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Официальный сайт")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.licenseItems.length
        ? _c(
            "button",
            {
              staticClass:
                "information-actions__button d-flex align-center justify-center ga-2 bg-gray-40 rounded-10 px-2 py-4 w-100 text-subtitle-1 text--text",
              attrs: { type: "button", "data-qa": "lpu_information_license" },
              on: { click: _setup.openLicense },
            },
            [
              _c("span", {
                staticClass:
                  "ui-icon-icon-document-text ui-icon-fz-big flex-shrink-0",
              }),
              _vm._v("\n    " + _vm._s(_setup.tStatic("Лицензия")) + "\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.CoreImageLightbox, {
        ref: "lightboxRef",
        attrs: { items: _vm.licenseItems },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }